import React, { useEffect, useState } from "react";
import FullScreenDropdown from "./FullScreenDropdown.tsx";
import ProfileDropdown from "./ProfileDropdown.tsx";

const Navbar = ({ onMenuClick, isSidebarOpen, headerClass }) => {
    const [username, setUsername] = useState("");
    const [storageName, setStorageName] = useState("");

    useEffect(() => {
        const getUsernameFromToken = () => {
            const token = sessionStorage.getItem("access_token");
            if (token) {
                try {
                    const payload = JSON.parse(atob(token.split(".")[1]));
                    setUsername(
                        (payload.first_name || payload.last_name)
                            ? (payload.first_name || "") + " " + (payload.last_name || "")
                            : payload?.sub ? payload.sub : "User"
                    );
                } catch (error) {
                    console.error("Error decoding token:", error);
                }
            }
        };

        getUsernameFromToken();
    }, []);

    useEffect(() => {
        const updateUserName = () => {
            setStorageName(sessionStorage.getItem("userName") || "User");
        };

        window.addEventListener("userNameUpdated", updateUserName);
        updateUserName();

        return () => window.removeEventListener("userNameUpdated", updateUserName);
    }, []);

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">
                            <button
                                onClick={onMenuClick}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none order-1 order-md-2"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>
                        <div className="d-flex align-items-center ">

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />
                            {/* ProfileDropdown */}
                            <ProfileDropdown />

                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Navbar;